import { TextInput, TextInputProps } from '@infotech-soe/erp-ui-kit';
import React from 'react';

import { TextInputFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';

import { TFormControlConnectorProps } from './FormControlContainer';
import FormLabeledInputControl from './FormLabeledInputControl';
import FormTextControl from './hoc/FormTextControl';
import { RequiredHistoryProps, withHistory } from './hoc/HistoryContainer';
import UpdaterButton from './UpdaterButton';
interface Props
  extends
    RequiredHistoryProps<HTMLInputElement>,
    Pick<TFormControlConnectorProps, 'areHintsShown' | 'onRunSingleUpdater'>,
    Pick<
      TextInputProps,
      | 'className'
      | 'keymap'
      | 'onChange'
      | 'onChanged'
      | 'onSubmit'
      | 'onValidate'
    > {
  control: TextInputFormControlViewModel;
  value: string;
}

const FormTextInputControl: React.FC<Props> = ({
  areHintsShown,
  className,
  control,
  keymap,
  onRef,
  rounded,
  value,
  onChange,
  onChanged,
  onRunSingleUpdater,
  onSubmit,
  onValidate,
}) => (
  <FormLabeledInputControl areHintsShown={areHintsShown} control={control}>
    <TextInput
      allowTextOverflow
      className={className}
      containerRef={onRef}
      disabled={control.disabled}
      invalid={control.invalid}
      keymap={keymap}
      lengthInBytes={control.lengthInBytes}
      maxLength={control.maxLength}
      name={control.name}
      onChange={onChange}
      onChanged={onChanged}
      onSubmit={onSubmit}
      onValidate={onValidate}
      placeholder={control.placeholder}
      readOnly={control.readonly}
      regExp={control.regExp}
      required={control.required}
      rounded={rounded}
      type={control.maskPassword ? 'password' : 'text'}
      value={value}
      endSlot={
        control.updater ? (
          <UpdaterButton control={control} updater={onRunSingleUpdater} />
        ) : undefined
      }
    />
  </FormLabeledInputControl>
);

export default withHistory(FormTextControl(FormTextInputControl));
